import { apiRequest } from '../client'

export interface EslConfig {
  enabled: boolean
  shopNumber?: string | null
  apiKey?: string | null
  lastSyncAt?: string | null
  lastSyncStatus?: string | null
  lastSyncError?: string | null
}

export interface EslConfigRequest {
  enabled: boolean
  shopNumber: string | null
  apiKey: string | null
}

export interface EslTestConnectionResult {
  ok: boolean
  error?: string
}

const base = (restaurantId: number) =>
  `/api/v0/admin/restaurants/${restaurantId}/esl-config`

export const eslApi = {
  getConfig: (restaurantId: number) =>
    apiRequest<EslConfig>(base(restaurantId)),

  saveConfig: (restaurantId: number, data: EslConfigRequest) =>
    apiRequest<EslConfig>(base(restaurantId), {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  testConnection: (restaurantId: number, apiKey: string) =>
    apiRequest<EslTestConnectionResult>(
      `${base(restaurantId)}/test-connection`,
      {
        method: 'POST',
        body: JSON.stringify({ apiKey }),
      },
    ),

  syncNow: (restaurantId: number) =>
    apiRequest<{ ok: boolean }>(`${base(restaurantId)}/sync-now`, {
      method: 'POST',
    }),
}
